import { render, staticRenderFns } from "./RelatorioGestao.vue?vue&type=template&id=3a5fd9d3&scoped=true"
import script from "./RelatorioGestao.vue?vue&type=script&lang=ts"
export * from "./RelatorioGestao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5fd9d3",
  null
  
)

export default component.exports